import { render, staticRenderFns } from "./account-navigation.vue?vue&type=template&id=4351f8e9"
import script from "./account-navigation.vue?vue&type=script&lang=js"
export * from "./account-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports